(function(){
  document.addEventListener('DOMContentLoaded', function() {
    
window.initJsSlideProduct = () => {

  document.addEventListener('click', (event) => {
    // 1. Закрытие по клику на фон (backdrop)
    // Проверяем, что кликнули именно по тегу DIALOG
    if (event.target.tagName === 'DIALOG') {
      event.target.close();
    }

    // 2. Закрытие по любой кнопке с атрибутом data-close-dialog
    // Полезно, если хочешь сделать кастомную кнопку закрытия или крестик
    if (event.target.closest('[data-close-dialog]')) {
      const dialog = event.target.closest('dialog');
      if (dialog) dialog.close();
    }
  });


  // Исправленная функция проигрывания видео
  function isVideoPlay(swiper) {
    const activeSlide = swiper.el.querySelector('.swiper-slide-active');
    if (!activeSlide) return;

    const poster = activeSlide.querySelector('.deferred-media__poster');
    const video = activeSlide.querySelector('video');

    // Если есть постер (deferred media), кликаем по нему
    if (poster) {
      poster.click();
      setTimeout(() => {
        const deferredVideo = activeSlide.querySelector('video');
        if (deferredVideo) {
          deferredVideo.play().catch(e => console.warn("Video play blocked:", e));
        }
      }, 500);
    } 
    // Если видео уже в DOM
    else if (video) {
      video.play().catch(e => console.warn("Video play blocked:", e));
    }
  }

  let containerProduct = document.querySelectorAll('product-info');

  containerProduct.forEach(elem => {
  let thumbItem = elem.querySelector('.js-product-thumbnail-slider');
  let mainItem = elem.querySelector('.js-product-main-slider');

  if (!thumbItem || !mainItem) return;

  // Инициализируем превью (Thumbnail Slider)
  let sliderThumbnail = new Swiper(thumbItem, {
    spaceBetween: 15,
    slidesPerView: 4,
    watchSlidesProgress: true,
    slideToClickedSlide: true,
    centerInsufficientSlides: true,
    threshold: 10, // КРИТИЧНО: Игнорирует мелкие сдвиги, фиксируя клик
    freeMode: false, // Отключаем, чтобы не было "плавания"
    touchMoveStopPropagation: true,
    breakpoints: {
      320: {
        direction: 'horizontal',
        slidesPerView: 4,
        spaceBetween: 15,
        centerInsufficientSlides: true
      },
      640: {
        direction: 'horizontal',
        slidesPerView: 6,
        spaceBetween: 15,
        centerInsufficientSlides: true
      },
      // Desktop: vertical rail next to the main image (see section-main-product.css)
      990: {
        direction: 'vertical',
        slidesPerView: 'auto',
        spaceBetween: 10,
        centerInsufficientSlides: false
      }
    }
  });

  // Инициализируем главный слайдер
  window.galleryMain = new Swiper(mainItem, {
    initialSlide: 0,
    threshold: 5,
    thumbs: {
      swiper: sliderThumbnail 
    },
    on: {
      slideChangeTransitionEnd: function() {
        // changeVariantByImage(this);
        if (this.touches.diff !== 0 || this.navigation.nextEl === document.activeElement || this.navigation.prevEl === document.activeElement) {
           changeVariantByImage(this);
        }
        isVideoPlay(this);
      }
    },
    navigation: {
      nextEl: mainItem.querySelector('.swiper-button-next'),
      prevEl: mainItem.querySelector('.swiper-button-prev'),
    }
  });
});

  /**
   * Синхронизация слайдера при изменении варианта (через селектор)
   */
  let productCur = document.querySelector('[data-tb-variants-json]');
  if (productCur) {
    productCur = JSON.parse(productCur.getAttribute('data-tb-variants-json'));
  }

  function variantImage(val) {
    const selectedVariantId = parseInt(val, 10);
    const variant = productCur.find(v => v.id === selectedVariantId);
    
    if (variant && variant.featured_media) {
      const mediaId = variant.featured_media.id;
      // Ищем слайд, у которого data-for-slick совпадает с ID медиа
      const targetSlide = document.querySelector(`.js-product-main-slider [data-for-slick="${mediaId}"]:not(.swiper-slide-duplicate)`);
      
      if (targetSlide && window.galleryMain) {
        const index = Array.from(targetSlide.parentNode.children).indexOf(targetSlide);
        window.galleryMain.slideTo(index);
      }
    }
  }

  const initialColorVariant = document.querySelector('product-info .product-variant-id');
  initialColorVariant?.addEventListener('change', function() {
    if (this.value) variantImage(this.value);
  });

  /**
   * Смена варианта при клике/свайпе слайда
   */
  function changeVariantByImage(swiper) {
    let productObj = document.querySelector('[data-tb-variants-json]');
    if (!productObj) return;
    productObj = JSON.parse(productObj.getAttribute('data-tb-variants-json'));

    const activeSlide = swiper.slides[swiper.activeIndex];
    const mediaId = activeSlide?.getAttribute('data-for-slick');

    if (!mediaId) return;

    let selectedVariantId = parseInt(mediaId, 10);
    let variant = productObj.find(v => v.featured_media?.id === selectedVariantId && v.available);

    if (variant) {
      variant.options.forEach(option => {
        // Ищем input/radio и имитируем клик
        const inputOption = document.querySelector(`input[value="${option.replace(/"/g, '\\"')}"] + label`);
        if (inputOption) inputOption.click();
      });
    }
  }
};

    window.initJsSlideProduct();
// Инициализируем глобальный контроллер защиты, если его еще нет
if (!window.PreorderEnforcerController) {
  window.PreorderEnforcerController = {
    isProcessing: false,
    lastRequestId: null
  };
}

// Инициализация глобального контроллера, если он еще не создан
if (!window.PreorderEnforcerController) {
  window.PreorderEnforcerController = {
    isProcessing: false,
    lastRequestId: null
  };
}

// class VariantList extends HTMLElement {
//   constructor() {
//     super();
//     // Массив ключей (line item keys) запрещенных товаров, которые нужно будет удалить
//     this.forbiddenItemKeys = []; 
//   }

//   connectedCallback() {
//     // СЛУЧАЙ 1: Проверка корзины сразу при загрузке страницы
//     this.checkCartOnLoad();

//     // СЛУЧАЙ 2: Подписка на обновления корзины в теме Dawn
//     if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
//       subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => this.handleCartUpdate(event));
//     } else {
//       document.addEventListener('cart:updated', (event) => this.handleCartUpdate(event));
//     }

//     // Делегированный обработчик клика по кастомной кнопке очистки
//     document.addEventListener('click', (e) => {
//       if (e.target && e.target.id === 'clear-preorder-conflicts') {
//         e.preventDefault();
//         this.removeForbiddenItems();
//       }
//     });
//   }

//   // Метод для первичной проверки корзины при загрузке страницы
//   async checkCartOnLoad() {
//     try {
//       const response = await fetch(`${window.Shopify.routes.root}cart.js`);
//       const cartData = await response.json();
//       if (cartData && cartData.items) {
//         this.validateCartStructure(cartData);
//       }
//     } catch (e) {
//       console.error('Ошибка при первичной проверке корзины:', e);
//     }
//   }

//   async handleCartUpdate(event) {
//     const controller = window.PreorderEnforcerController;

//     if (controller.isProcessing) return;

//     if (event?.source === 'preorder-enforcer' || event?.detail?.source === 'preorder-enforcer') {
//       return;
//     }

//     if (event?.cart && event.cart.request_id === controller.lastRequestId) {
//       return;
//     }
    
//     let cartData = null;
//     if (event.cart && event.cart.items) {
//       cartData = event.cart;
//     } else if (event.detail && event.detail.cart && event.detail.cart.items) {
//       cartData = event.detail.cart;
//     }

//     if (!cartData || !cartData.items) {
//       try {
//         const response = await fetch(`${window.Shopify.routes.root}cart.js`);
//         cartData = await response.json();
//       } catch (e) {
//         return;
//       }
//     }

//     if (cartData && cartData.items) {
//       this.validateCartStructure(cartData);
//     }
//   }

//   // Основной метод валидации состава корзины
//   validateCartStructure(cartData) {
//     const allowedVariantIds = this.getVariantIds();
//     if (!allowedVariantIds || allowedVariantIds.length === 0) {
//       this.toggleCheckoutButton(false);
//       this.toggleWarningMessage(false);
//       return;
//     }

//     let hasAllowedProduct = false;
//     let hasForbiddenProduct = false;
//     this.forbiddenItemKeys = []; // Сбрасываем старый список перед проверкой

//     cartData.items.forEach(item => {
//       const currentVariantId = Number(item.id);

//       if (allowedVariantIds.includes(currentVariantId)) {
//         hasAllowedProduct = true;
//       } else {
//         hasForbiddenProduct = true;
//         this.forbiddenItemKeys.push(item.key); // Запоминаем ключ для удаления
//       }
//     });

//     // Если обнаружено смешивание предзаказов и обычных товаров
//     if (hasAllowedProduct && hasForbiddenProduct) {
//       this.toggleCheckoutButton(true);
//       this.toggleWarningMessage(true);
//     } else {
//       this.toggleCheckoutButton(false);
//       this.toggleWarningMessage(false);
//     }
//   }

//   // Метод управления состоянием кнопок оформления заказа
//   toggleCheckoutButton(shouldDisable) {
//     const checkoutSelectors = [
//       'button[name="checkout"]',
//       '[data-cart-submit]',
//       '.cart__submit',
//       '#checkout',
//       '.cart__checkout-button'
//     ];
    
//     const checkoutButtons = document.querySelectorAll(checkoutSelectors.join(','));
    
//     checkoutButtons.forEach(button => {
//       if (shouldDisable) {
//         button.setAttribute('disabled', 'disabled');
//         button.style.opacity = '0.5';
//         button.style.pointerEvents = 'none';
//         button.title = "Remove regular pre-order items";
//       } else {
//         button.removeAttribute('disabled');
//         button.style.opacity = '1';
//         button.style.pointerEvents = 'auto';
//         button.title = "";
//       }
//     });
//   }

//   // Метод динамического рендеринга предупреждения и кнопки очистки
//   toggleWarningMessage(shouldShow) {
//     // Ищем контейнеры корзины (как Drawer, так и основную страницу корзины)
//     const cartContainers = document.querySelectorAll('.drawer__footer, .cart__blocks, cart-drawer-items, .cart__footer');
//     let warningElement = document.getElementById('preorder-enforcer-warning');

//     if (!shouldShow) {
//       if (warningElement) warningElement.remove();
//       return;
//     }

//     // Если предупреждение уже создано, не дублируем его
//     if (warningElement) return;

//     warningElement = document.createElement('div');
//     warningElement.id = 'preorder-enforcer-warning';
//     // Стилизуйте блок под дизайн вашей темы
//     warningElement.innerHTML = `
//       <div style="background: #fff3cd; color: #856404; padding: 15px; margin: 15px 0; border-radius: 4px; border: 1px solid #ffeeba; font-size: 14px; text-align: center;">
//         <p style="margin: 0 0 10px 0; font-weight: bold;">העגלה שלך מכילה פריטים בהזמנה מראש ופריטים רגילים. לא ניתן להכניס פריטים אלה לאותה הזמנה.</p>
//         <button id="clear-preorder-conflicts" class="button button--secondary" style="width: 100%; max-width: 300px; cursor: pointer;">
//           ברור ממוצרים רגילים
//         </button>
//       </div>
//     `;

//     // Вставляем предупреждение в первый найденный футер корзины
//     if (cartContainers.length > 0) {
//       cartContainers[0].parentNode.insertBefore(warningElement, cartContainers[0]);
//     }
//   }

//   // Метод пакетной очистки запрещенных товаров через AJAX API
//   async removeForbiddenItems() {
//     if (this.forbiddenItemKeys.length === 0) return;

//     const controller = window.PreorderEnforcerController;
//     controller.isProcessing = true;

//     const currentId = 'req_' + Math.random().toString(36).substr(2, 9);
//     controller.lastRequestId = currentId;

//     const updates = {};
//     this.forbiddenItemKeys.forEach(key => {
//       updates[key] = 0; // Выставляем нулевое количество для удаления
//     });

//     try {
//       const sectionsToRender = ['cart-drawer', 'cart-icon-bubble', 'main-cart-items'];
      
//       const requestBody = {
//         updates: updates,
//         sections: sectionsToRender.join(','),
//         sections_url: window.location.pathname
//       };

//       const updateResponse = await fetch(`${window.Shopify.routes.root}cart/update.js`, {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify(requestBody)
//       });

//       const updatedCartResponse = await updateResponse.json();

//       if (updatedCartResponse.status && updatedCartResponse.status === 429) {
//         throw new Error('code 429: too much requests to server');
//       }

//       updatedCartResponse.request_id = currentId;

//       // Возвращаем кнопку в активное состояние, так как корзина будет очищена
//       this.toggleCheckoutButton(false);
//       this.toggleWarningMessage(false);

//       this.refreshDawnCartComponents(updatedCartResponse);

//       if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
//         publish(PUB_SUB_EVENTS.cartUpdate, { 
//           cart: updatedCartResponse,
//           source: 'preorder-enforcer'
//         });
//       }

//     } catch (error) {
//       console.error('Eror clear cart:', error);
//       window.location.reload();
//     } finally {
//       setTimeout(() => {
//         controller.isProcessing = false;
//         controller.lastRequestId = null;
//       }, 1200);
//     }
//   }

//   refreshDawnCartComponents(updatedCart) {
//     const cartDrawer = document.querySelector('cart-drawer');
//     const cartNotification = document.querySelector('cart-notification');
//     const cartItems = document.querySelector('cart-items');

//     if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
//       cartDrawer.renderContents(updatedCart);
//     }
//     if (cartNotification && typeof cartNotification.renderContents === 'function') {
//       cartNotification.renderContents(updatedCart);
//     }
//     if (cartItems && window.location.pathname.includes('/cart')) {
//        window.location.reload();
//     }
//   }

//   getVariantIds() {
//     const variantsData = this.getAttribute('data-variants');
//     if (!variantsData) return [];
//     try {
//       return JSON.parse(variantsData).map(id => Number(id)).filter(Boolean);
//     } catch (e) {
//       return [];
//     }
//   }
// }

// if (!customElements.get('variant-list')) {
//   customElements.define('variant-list', VariantList);
// }

// Инициализация контроллера ДО определения класса — это была критическая ошибка
window.PreorderEnforcerController = window.PreorderEnforcerController || {
  isProcessing: false,
  lastRequestId: null
};

class VariantList extends HTMLElement {
  constructor() {
    super();
    this.forbiddenItemKeys = [];
    this._conflictState = false;
    this._observer = null;
    this._attrObserver = null;
    this._debounceTimer = null;
  }

  connectedCallback() {
    if (this._initialized) return;
    this._initialized = true;

    // Начальная проверка после рендера DOM
    if (document.readyState === 'complete') {
      this.validateCartFromDOM();
    } else {
      window.addEventListener('load', () => this.validateCartFromDOM(), { once: true });
    }

    this._setupObservers();

    document.addEventListener('click', (e) => {
      if (e.target?.id === 'clear-preorder-conflicts') {
        e.preventDefault();
        this.removeForbiddenItems();
      }
    });
  }

  _scheduleCheck() {
    clearTimeout(this._debounceTimer);
    this._debounceTimer = setTimeout(() => this.validateCartFromDOM(), 100);
  }

  _setupObservers() {
    // Observer 1: изменения внутри cart-drawer и его полная замена в DOM
    this._observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        const target = mutation.target;

        // Что-то изменилось внутри cart-drawer
        if (target.tagName === 'CART-DRAWER' || target.closest?.('cart-drawer')) {
          this._scheduleCheck();
          return;
        }

        // cart-drawer добавлен/заменён в DOM
        if (mutation.type === 'childList') {
          for (const node of mutation.addedNodes) {
            if (node.nodeType !== 1) continue;
            if (node.tagName === 'CART-DRAWER' || node.querySelector?.('cart-drawer')) {
              this._scheduleCheck();
              this._setupAttrObserver(); // переподключаем атрибут-observer к новому элементу
              return;
            }
          }
        }
      }
    });

    this._observer.observe(document.body, { childList: true, subtree: true });

    // Observer 2: открытие/закрытие cart-drawer (класс active)
    this._setupAttrObserver();
  }

  _setupAttrObserver() {
    this._attrObserver?.disconnect();

    const cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) {
      setTimeout(() => this._setupAttrObserver(), 300);
      return;
    }

    this._attrObserver = new MutationObserver(() => this._scheduleCheck());

    this._attrObserver.observe(cartDrawer, {
      attributes: true,
      attributeFilter: ['class', 'aria-expanded', 'aria-hidden']
    });
  }

  disconnectedCallback() {
    this._initialized = false;
    this._observer?.disconnect();
    this._attrObserver?.disconnect();
    this._observer = null;
    this._attrObserver = null;
  }

  validateCartFromDOM() {
    const allowedVariantIds = this.getVariantIds();
    if (!allowedVariantIds.length) {
      this._conflictState = false;
      this.toggleCheckoutButton(false);
      this.toggleWarningMessage(false);
      return;
    }

    // Ищем элементы корзины с data-variant-id в нужных контейнерах
    let cartItemEls = null;
    const containers = ['cart-drawer', 'cart-items', '.cart__items'];

    for (const selector of containers) {
      const container = document.querySelector(selector);
      if (container) {
        const items = container.querySelectorAll('[data-variant-id]');
        if (items.length) { cartItemEls = items; break; }
      }
    }

    if (!cartItemEls?.length) {
      // Корзина пуста или ещё не отрисована
      if (this._conflictState) {
        this._conflictState = false;
        this.toggleCheckoutButton(false);
        this.toggleWarningMessage(false);
      }
      return;
    }

    let hasAllowedProduct = false;
    let hasForbiddenProduct = false;
    this.forbiddenItemKeys = [];

    cartItemEls.forEach(el => {
      const variantId = Number(el.dataset.variantId);
      if (!variantId) return;

      if (allowedVariantIds.includes(variantId)) {
        hasAllowedProduct = true;
      } else {
        hasForbiddenProduct = true;
        if (el.dataset.lineKey) this.forbiddenItemKeys.push(el.dataset.lineKey);
      }
    });

    const conflict = hasAllowedProduct && hasForbiddenProduct;
    this._conflictState = conflict;
    this.toggleCheckoutButton(conflict);
    this.toggleWarningMessage(conflict);
  }

  toggleCheckoutButton(shouldDisable) {
    const selectors = [
      'button[name="checkout"]',
      '[data-cart-submit]',
      '.cart__submit',
      '#checkout',
      '.cart__checkout-button'
    ];

    document.querySelectorAll(selectors.join(',')).forEach(button => {
      if (shouldDisable) {
        button.setAttribute('disabled', 'disabled');
        button.style.opacity = '0.5';
        button.style.pointerEvents = 'none';
        button.title = 'Remove regular items to proceed';
      } else {
        button.removeAttribute('disabled');
        button.style.opacity = '';
        button.style.pointerEvents = '';
        button.title = '';
      }
    });
  }

  toggleWarningMessage(shouldShow) {
    let warningEl = document.getElementById('preorder-enforcer-warning');

    if (!shouldShow) {
      warningEl?.remove();
      return;
    }

    if (warningEl) return;

    warningEl = document.createElement('div');
    warningEl.id = 'preorder-enforcer-warning';
    warningEl.innerHTML = `
      <div style="background:#fff3cd;color:#856404;padding:15px;margin:15px 0;border-radius:4px;border:1px solid #ffeeba;font-size:14px;text-align:center;">
        <p style="margin:0 0 10px 0;font-weight:bold;">העגלה שלך מכילה פריטים בהזמנה מראש ופריטים רגילים. לא ניתן להכניס פריטים אלה לאותה הזמנה.</p>
        <button id="clear-preorder-conflicts" class="button button--secondary" style="width:100%;max-width:300px;cursor:pointer;">
          ברור ממוצרים רגילים
        </button>
      </div>
    `;

    const targets = document.querySelectorAll('.drawer__footer, .cart__blocks, cart-drawer-items, .cart__footer');
    if (targets.length > 0) {
      targets[0].parentNode.insertBefore(warningEl, targets[0]);
    } else {
      document.body.appendChild(warningEl);
    }
  }

  async removeForbiddenItems() {
    if (!this.forbiddenItemKeys.length) return;

    const controller = window.PreorderEnforcerController;
    if (!controller) return;

    controller.isProcessing = true;
    const currentId = 'req_' + Math.random().toString(36).substr(2, 9);
    controller.lastRequestId = currentId;

    const updates = {};
    this.forbiddenItemKeys.forEach(key => { updates[key] = 0; });

    try {
      const response = await fetch(`${window.Shopify.routes.root}cart/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          updates,
          sections: 'cart-drawer,cart-icon-bubble,main-cart-items',
          sections_url: window.location.pathname
        })
      });

      if (response.status === 429) throw new Error('Rate limited (429)');

      const updatedCart = await response.json();
      updatedCart.request_id = currentId;

      this._conflictState = false;
      this.toggleCheckoutButton(false);
      this.toggleWarningMessage(false);

      this.refreshDawnCartComponents(updatedCart);

      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          cart: updatedCart,
          source: 'preorder-enforcer'
        });
      }

    } catch (error) {
      console.error('PreorderEnforcer: removeForbiddenItems error:', error);
      window.location.reload();
    } finally {
      setTimeout(() => {
        controller.isProcessing = false;
        controller.lastRequestId = null;
      }, 1200);
    }
  }

  refreshDawnCartComponents(updatedCart) {
    const cartDrawer = document.querySelector('cart-drawer');
    const cartNotification = document.querySelector('cart-notification');
    const cartItems = document.querySelector('cart-items');

    if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
      cartDrawer.renderContents(updatedCart);
    }
    if (cartNotification && typeof cartNotification.renderContents === 'function') {
      cartNotification.renderContents(updatedCart);
    }
    if (cartItems && window.location.pathname.includes('/cart')) {
      window.location.reload();
    }
  }

  getVariantIds() {
    const variantsData = this.getAttribute('data-variants');
    if (!variantsData) return [];
    try {
      return JSON.parse(variantsData).map(id => Number(id)).filter(Boolean);
    } catch (e) {
      return [];
    }
  }
}

if (!customElements.get('variant-list')) {
  customElements.define('variant-list', VariantList);
}
 }, false);
})();
